import { useState, useCallback, useEffect } from 'react';
import api from '../services/api';

/**
 * Hook para buscar keywords do briefing ativo para highlighting automático
 */
const useBriefingKeywords = ({ enabled = true } = {}) => {
    const [keywords, setKeywords] = useState({ primary: [], competitor: [] });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Buscar keywords do briefing
    const fetchKeywords = useCallback(async () => {
        if (!enabled) {
            setKeywords({ primary: [], competitor: [] });
            setLoading(false);
            setError(null);
            return;
        }

        try {
            setLoading(true);
            setError(null);
            const response = await api.get('/briefing/keywords');
            setKeywords(response.data.data || { primary: [], competitor: [] });
        } catch (err) {
            console.error('Erro ao carregar keywords do briefing:', err);
            setError(err.message);
            setKeywords({ primary: [], competitor: [] });
        } finally {
            setLoading(false);
        }
    }, [enabled]);

    // Carregar keywords ao montar
    useEffect(() => {
        if (enabled) {
            fetchKeywords();
        } else {
            setKeywords({ primary: [], competitor: [] });
            setLoading(false);
            setError(null);
        }
    }, [enabled, fetchKeywords]);

    return {
        keywords,
        loading,
        error,
        refetch: fetchKeywords
    };
};

export default useBriefingKeywords;
